
var values = [];
var Filters = {

    init: function () {

        /*
        console.log($('#searchFilterusers').dropdown());
        $('.dropdown-menu').dropdown('show.bs.hidden', function () {
            console.log($(this)); 
        });
        */

        $('.dropdown-filter .dropdown').on('hidden.bs.dropdown', function () {
            $(this).find('.search-filter input').val('');
            $(this).find('.search-filter input').trigger('input');
        });

        $('.dropdown-menu.keep-open').on('click', function (e) {
            e.stopPropagation();
        });

        $('.search-filter input').on('input', function (e) {
            $theinput = $(this);
            $debounceSearch($theinput);
        });
        var $debounceSearch = debounce(function ($theinput) {
            var $q = $theinput.val();
            var $thePartial = $($theinput.data('partial'));
            $thePartial.data('q', $q);
            load_partial( $thePartial );
        }, 300);
    },

    tagsCheckboxChanged: function ($this) {               
        var $name   = $this.attr('name');
        var $type   = $this.attr('type');
        var $id     = $this.attr('id');
        var $value  = $this.val();
        var $label  = $this.data('label');        

        var $target_template   = $this.data('template');
        var $partialTargetEl   = $($this.data('list-target'));
        var $filterPartial     = $this.data('filter-partial');        
        var $values            = $partialTargetEl.data($name);

        if ($this.get(0).checked) {
            $template = `<div class="tag col-auto" data-filter-partial="${$filterPartial}" data-list-target="${$this.data('list-target')}"  data-name="${$name }" data-value="${$value}">
                            ${ $label }
                            <button type="button" class="close" onClick="Filters.tagsCheckboxCloseBtn($(this));"><svg width="8" height="8" viewBox="0 0 8 8"  xmlns="http://www.w3.org/2000/svg"><path d="M5.59977 4L8 6.40023L6.40023 8L4 5.59977L1.59977 8L0 6.40023L2.40023 4L0 1.59977L1.59977 0L4 2.40023L6.40023 0L8 1.59977L5.59977 4Z" /></svg></button>
                        </div>`;

            if ($type == "radio") {
                $($target_template).find('.filter-template-content').empty()                
            }
            $($target_template).find('.filter-template-content').append($template);
            $($target_template).show();
            Filters.updateListParams({
                action:'add',
                list_partial:$partialTargetEl,
                filter_partial:$this.data('filter-partial'),
                selected_filters:$($target_template),
                name:$name,
                value:$value,
                values:$values,
            });

        } else {

            Filters.updateListParams({
                action:'remove',
                list_partial:$partialTargetEl,
                filter_partial:$this.data('filter-partial'),
                selected_filters:$($target_template),
                name:$name,
                value:$value,
                values:$values,
            });
        }
      

    },

    tagsCheckboxCloseBtn: function ($this) {
        var $theTag        = $this.closest('.tag');
        var $name          = $theTag.data('name');
        var $listPartialSelector    = $theTag.data('list-target');
        var $listPartialElement    = $($listPartialSelector);

        var value          = $theTag.data('value');
        var $template      = $theTag.closest('.template');
        var $values        = $listPartialElement.data($name);

        console.log($listPartialElement,$name);

        var $filterPartial = $this.closest('.tag').data('filter-partial');        
        $( $filterPartial ).find('input[value="'+value+'"]').prop("checked", false);
      
        if ($template.find('.tag').length == 0) {
            $template.hide();
        }
        Filters.updateListParams({
            action:'remove',            
            list_partial       : $listPartialElement,
            filter_partial     : $filterPartial ,
            selected_filters   : $theTag.closest('.template'),
            name    : $theTag.data('name'),
            value   : $theTag.data('value'),
            values  : $values,
        });
        $theTag.remove();
    },

    updateListParams: function(data){                
        /*
        data = {
            action:'remove/add',
            list_partial:'list_partial',
            filter_partial:'filter_partial',
            selected_filters:'selected_filters',
            name:'option name',
            value:'option value',
            values:'list_partial-values',        
        }*/

        
        if (data.action == 'add') {
            if(typeof data.values === 'undefined'){
                data.values = data.value;
            }else{
                data.values = data.values.toString().split(",");
                if(!data.values.includes(data.value)){
                    data.values.push(data.value)
                }
                data.values = data.values.join(',');
            }            
        }

        if(data.action === 'remove'){
            

            if(!Array.isArray(data.values)){                
                data.values = data.values.toString().split(",")  ;
            }else{
                data.values =  data.values.join(',');
            }
            data.values =  data.values.filter(item => item != data.value );  
            data.values = data.values.join(',');

            data.selected_filters.find('.tag[data-name="' + data.name + '"][data-value="' + data.value + '"]').remove();
            if (data.selected_filters.find('.tag').length == 0) {
                data.selected_filters.hide();
            }         
        }

        if(data.filter_partial){
            $(data.filter_partial).data( 'selected_'+data.name, data.values );         
        }
        
        $(data.filter_partial).data( 'page', 1);

        data.list_partial.data( data.name, data.values );
        load_partial(data.list_partial);
        scroll2element(data.list_partial);
    },

  

    

    removeAllFilters: function ($this) {
        
        var $listTargetSelector     = $this.data('list-target');
        var $listTargetElement      = $($listTargetSelector);
        var $filterPartialSelector  = $this.data('filter-partial');
        var $filterPartialElement   = $($filterPartialSelector);
        var $name                   = $this.data('name');

        $filterPartialElement.find('input[type="checkbox"],input[type="radio"]').prop('checked', false);

        $this.closest('.template').find('.tag').remove();
        $this.closest('.template').hide();
        if($filterPartialElement.length>0){             
            $filterPartialElement.data( 'selected_'+$this.data('name'), '');      
            load_partial($filterPartialElement);         
        }
        $listTargetElement.data( $this.data('name'), '' );
        load_partial($listTargetElement);  
        scroll2element($listTargetElement);
    }, 
    softRemoveAllFilters: function ($this) {

        var $listTargetSelector     = $this.data('list-target');
        var $listTargetElement      = $($listTargetSelector);
        var $filterPartialSelector  = $this.data('filter-partial');
        var $filterPartialElement   = $($filterPartialSelector);

        var $templateSelector  = $this.data('template');
        var $templateElement   = $($templateSelector);
        var $name              = $this.data('name');

        $filterPartialElement.find('input[type="checkbox"],input[type="radio"]').prop('checked', false);

        $templateElement.find('.filter-template-content').empty();
        $templateElement.hide();

        if($filterPartialElement.length>0){             
            $filterPartialElement.data( 'selected_'+$this.data('name'), '');      
            load_partial($filterPartialElement);         
        }
        $listTargetElement.data( $this.data('name'), '' );         
        scroll2element($filterPartialElement);
    }, 
    

}



